module.exports = __webpack_public_path__ + "static/media/snackpeppers.5f12b7c3.webp";